import PolicyFetchRequestStatus from './schema/PolicyFetchRequestStatus';
import RetentionPoliciesOptionState from './schema/RetentionPoliciesOptionState';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

const getStore = createStore<RetentionPoliciesOptionState>('retentionPoliciesOption', {
    activePoliciesListState: {
        retentionPolicies: new ObservableMap(),
        fetchRequestStatus: PolicyFetchRequestStatus.NotInitiated,
        retentionPolicyIds: [],
        isStale: true,
    },
    availablePoliciesListState: {
        retentionPolicies: new ObservableMap(),
        fetchRequestStatus: PolicyFetchRequestStatus.NotInitiated,
        retentionPolicyIds: [],
        isStale: true,
    },
    isUserAtActivePolicies: true,
});

export const retentionPolicyStore = getStore();
export default getStore;
